import { InfoIcon } from "@phosphor-icons/react";

import { Button, Text } from "@alpacahq/ui/old";

import { SealCheckIcon } from "~/v2/components/common";

const STOCK_LENDING_FAQ_URL =
  "https://alpaca.markets/support/tag/stock-lending";

const ITEMS: ItemProps[] = [
  {
    title: "Earn up to 50%*",
    description: "Let your portfolio generate extra income automatically",
  },
  {
    title: "Fully Automated",
    description:
      "We spot eligible shares, lend them when there's demand, and back every loan with cash collateral.",
  },
  {
    title: "Stay in Full Control",
    description:
      "You remain the owner of your shares at all times. Trade, sell, or opt out anytime.",
  },
];

export const Benefits = () => {
  const onMoreInfoClicked = () => {
    window.open(STOCK_LENDING_FAQ_URL, "_blank", "noopener,noreferrer");
  };

  return (
    <article className="flex flex-col gap-3 rounded-lg bg-indigo-50 p-3">
      <div className="flex items-center justify-between gap-4">
        <div className="flex items-center gap-1">
          <InfoIcon size={20} className="text-indigo-600" />
          <h3 className="m-0 p-0 font-semibold text-base text-gray-800">
            Program Benefits
          </h3>
        </div>
        <Button variant="v2/ghost" size="v2/small" onClick={onMoreInfoClicked}>
          More Info
        </Button>
      </div>
      <div className="flex flex-col gap-3">
        {ITEMS.map((item) => (
          <Item key={item.title} {...item} />
        ))}
      </div>
    </article>
  );
};

interface ItemProps {
  title: string;
  description: string;
}

const Item = ({ title, description }: ItemProps) => (
  <div className="grid grid-cols-[20px_auto] grid-rows-[auto_auto] gap-x-2 gap-y-1">
    <SealCheckIcon />
    <h4 className="col-start-2 col-end-3 row-start-1 row-end-2 m-0 p-0 font-semibold text-gray-700 text-sm">
      {title}
    </h4>
    <Text className="col-start-2 col-end-3 row-start-2 row-end-3 text-gray-700 text-sm">
      {description}
    </Text>
  </div>
);
